'use strict';

import 'regenerator-runtime/runtime';

import { createAccountSdk, getAccountSdk } from 'account-sdk-browser-v6';
import { enableLegacyCompatibility } from 'account-sdk-browser-v6/compatibility';

/**
 * Logout the user from merchant
 * @return {Promise}
 */
function logoutMerchant() {
    return fetch('/logout', { credentials: 'include' })
        .then(() => window.location.reload())
        .catch(err => alert(`Failed to logout ${String(err)}`));
}

function $$(klass) {
    return document.getElementsByClassName(klass)[0]
}

document.addEventListener("DOMContentLoaded", async function() {
    const {
        clientId,
        sessionDomain,
        spidEnv,
    } = window.config;
    const redirectUri = `${window.location.origin}/safepage`;
    enableLegacyCompatibility();
    createAccountSdk({
        clientId,
        sessionDomain,
        env: spidEnv,
        log: console.log,
        redirectUri,
        generateState,
        callbackBeforeRedirect:()=>{
            console.log('Before redirect callback begin');

            return new Promise((resolve)=>{
                setTimeout(()=>{
                    console.log('Before redirect callback resolved');
                    resolve('ok!')
                }, 2000)
            })
        }
    });

    const account = await getAccountSdk();

    account.on('loginRequested', event => console.log('SSO login flow started.', event.detail));

    account.on('logoutRequested', event => console.log('SSO logout flow started.', event.detail));
    account.on('sessionUpdated', event => console.log('SSO session updated.', event.detail));

    const NAMESPACE = {
        LOCAL: 'id.localhost',
        DEV: 'schibsted.com',
        PRE: 'schibsted.com',
        PRO: 'schibsted.com',
        PRO_NO: 'spid.no',
        PRO_FI: 'schibsted.fi',
        PRO_DK: 'schibsted.dk',
    };

    /**
     * Checks if the user is logged in to SSO and updates the page accordingly
     * @return {void}
     */
    async function isLoggedInToSSO() {
        try {
            const loggedIn = await account.isLoggedIn();
            $$('is-logged-in-to-sso').textContent = (loggedIn ? 'Yes' : 'No');
            if (loggedIn) {
                const userInfo = document.getElementById('userInfo');
                const img = document.querySelector('#userInfo > img');
                if (img) {
                    const a = document.createElement('a');
                    a.href = account.accountUrl();
                    a.title = "Account page";
                    userInfo.removeChild(img);
                    a.appendChild(img);
                    userInfo.appendChild(a);
                }
            }
        } catch (err) {
            $$('is-logged-in-to-sso').textContent = `Error: ${err}`;
        }
    }

    async function isLoggedInViaCompatibility() {
        const result = $$('is-logged-in-via-compatibility');
        result.textContent = 'checking...';
        try {
            const loggedIn = await window.schIdentity.isLoggedIn();
            result.textContent = loggedIn ? 'Yes' : 'No';
        } catch (err) {
            result.textContent = `Error: ${err}`;
        }
    }

    /**
     * Checks if the user is connected to this merchant
     * @return {void}
     */
    function isConnected() {
        account.isConnected()
            .then(con => {
                const e = $$('user-is-connected-to-merchant');
                e.textContent = (con ? 'Yes' : 'No');
                e.removeAttribute('title');
            })
            .catch(err => $$('user-is-connected-to-merchant').textContent = `Error: ${err}`);
    }


    /**
     * Gets the user information (given that they are logged in and connected)
     * @return {void}
     */
    function getUserSSO() {
        account.getUser()
            .then(user => $$('user-info-sso').textContent = JSON.stringify(user, undefined, 2))
            .catch(err => $$('user-info-sso').textContent = `Error: ${err}`);
    }

    /**
     * Gets the user info using the access token in the backend
     * @return {void}
     */
    async function getUserToken() {
        try {
            const response = await fetch('/userinfo', { credentials: 'include' });
            const json = await response.json();
            $$('user-info-token').textContent = JSON.stringify(json, undefined, 2);
        } catch (err) {
            $$('user-info-token').textContent = `Error: ${err.responseText}`;
        }
    }

    /**
     * Introspects the token
     * @return {void}
     */
    async function introspectToken() {
        try {
            const response = await fetch('/introspect', { credentials: 'include' });
            const json = await response.json();
            $$('token-introspection-result').textContent = JSON.stringify(json, undefined, 2)
        } catch (err) {
            $$('token-introspection-result').textContent = `Error: ${err}`
        }
    }

    /**
     * Checks if the user is logged in to merchant and updates the page
     * @return {void}
     */
    async function isLoggedInToMerchant() {
        try {
            const response = await fetch('/isloggedin', { credentials: 'include' });
            const json = await response.json();
            const e = $$('is-logged-in-to-merchant');
            e.textContent = json.isLoggedin;
            e.removeAttribute('title');
        } catch (error) {
            const e = $$('is-logged-in-to-merchant');
            e.textContent = error;
            e.setAttribute('title', error.responseText);
        }
    }

    async function simplifiedLoginWidget(e) {
        e.preventDefault();

        const loginParams = {
            scope: 'openid profile',
        };

        try {
            await account.showSimplifiedLoginWidget(loginParams);
        } catch (err) {
            console.log(err);
        }
    }

    $$('update-is-logged-in-to-sso').onclick = isLoggedInToSSO;
    $$('update-is-logged-in-via-compatibility').onclick = isLoggedInViaCompatibility;
    $$('update-is-connected').onclick = isConnected;
    $$('get-user-info-sso').onclick = getUserSSO;
    $$('get-user-info-token').onclick = getUserToken;
    $$('query-merchant-log-in').onclick = isLoggedInToMerchant;
    $$('introspect-token').onclick = introspectToken;
    $$('simplified-login-widget-trigger').onclick = simplifiedLoginWidget;

    isLoggedInToSSO();
    isLoggedInViaCompatibility();
    isLoggedInToMerchant();
    isConnected();
    initializeOnlyOneCheckboxChosen('bankId');

    function generateState(browserWindow, preferPopup = false) {
        const char = () => Math.floor((Math.random() * (122 - 97)) + 97);
        const stateObj = {
            id: Array.from({length: 20}, () => String.fromCharCode(char())).join(''),
            popup: preferPopup,
            returnTo: browserWindow.location.pathname,
        };
        return browserWindow.btoa(JSON.stringify(stateObj));
    }

    function initializeOnlyOneCheckboxChosen(name) {
        document
            .querySelectorAll('input[type=checkbox][data-only-one-chosen='+name+']')
            .forEach((changedCheckbox, key, parent) => {
                changedCheckbox.addEventListener('change', () => {
                    parent.forEach((checkbox) => {
                        if (checkbox !== changedCheckbox) {
                            checkbox.checked = false
                        }
                    });
                })
            })
    }

    function login(e) {
        e.preventDefault();

        const preferPopup = document.getElementById('use-popup').checked;
        const state = preferPopup ? generateState(window, true) : undefined;
        const getAcrValues = () => {
            const checkedAcr = document.querySelectorAll('[name=login-method]:checked');
            const acrs = [];
            for (let acr of checkedAcr) {
                acrs.push(acr.value);
            }
            return acrs.join(' ');
        };

        const loginOptions = {
            state,
            scope: 'openid profile',
            acrValues: getAcrValues(),
            preferPopup,
            loginHint: document.getElementById('preferred-email').value,
            oneStepLogin: document.getElementById('one-step-login').checked,
        };
        const popup = account.login(loginOptions);
        
        if (popup) {
            window.addEventListener("message", event => {
                if (!(event.origin === window.location.origin || Object.is(event.source, popup))) {
                    return;
                }
                const data = JSON.parse(event.data);
                console.log('Message from popup:', data);
                popup.close();
                isLoggedInToSSO();
                isLoggedInToMerchant();
                isConnected();
            });
        }
    }

    Array.prototype.forEach.call(document.getElementsByClassName('login'), e => e.onclick = login);

    $$('logout-sso').onclick = function (e) {
        e.preventDefault();
        account.logout(`${window.location.origin}${window.location.pathname}`);
    };

    $$('logout-merchant').onclick = function (e) {
        e.preventDefault();
        logoutMerchant();
    };

    const monetizationCheckHasAccess = async (e) => {
        try {
            e.preventDefault();
            const productIds = $$('has-access-id').value.split(',').map(productId => productId.trim());
            const result = await account.hasAccess(productIds);
            const resultDiv = document.createElement('pre');
            resultDiv.innerText = JSON.stringify(result, null, 2);
            $$('has-access-container').appendChild(resultDiv);
        } catch (err) {
            const errorDiv = document.createElement('pre');
            errorDiv.innerText = `Error: ${err}`;
            $$('has-access-container').appendChild(errorDiv);
        }
    };

    $$('has-access').onclick = monetizationCheckHasAccess;

    async function passwordlessLogin(email) {
        const client_sdrn = `sdrn:${NAMESPACE[spidEnv]}:client:${clientId}`;
        const response = await fetch(`${sessionDomain}/passwordless/start`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            mode: 'cors',
            body: new URLSearchParams(
                {
                    email,
                    client_sdrn,
                    scope: 'openid profile',
                    redirect_uri: redirectUri,
                    response_type: 'code',
                    state: generateState(window),
                }
            )
        });

        const { passwordless_token } = await response.json();

        return async (code) => {
            const response = await fetch(`${sessionDomain}/passwordless/verify`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                mode: 'cors',
                body: new URLSearchParams(
                    {
                        passwordless_token,
                        client_sdrn,
                        code,
                    }
                ),
            });

            const { redirect_url } = await response.json();
            if (redirect_url) {
                window.location = redirect_url;
            }
        };
    }

    const startPasswordless = async () => {
        const submitCode = await passwordlessLogin($$('passwordless-email').value);
        $$('passwordless-code').focus();
        $$('submit-passwordless-code').onclick = () => {
            submitCode($$('passwordless-code').value);
        }
    };

    $$('submit-passwordless-email').onclick = startPasswordless;
});
